export const PAGE = {
  COTTO: '100207768987988',
  TRUEIDTEST: '109674367070653',
  TRUEID: '1858940081055826',
  YASALE: '100701258941039',
  THAILANDPOSTMARTTEST: '115414076948160',
  POWERBUY_MAIN_PAGE: '105046831863695',
  POWERBUY_SHOP_SERVICES: [
    'L1656221467',
    'L1656909148',
    '301460564518350',
    '106229284674746',
    '105344925152387'
  ],
  AIRA_AIFUL: ['1637674519806774', '105017609020919'],
  GPF_BUDDY: ['103823529112921', '103223705959634']
}



// WEBPACK FOOTER //
// ./src/constants/page.js